import React from "react";
import { bool } from "prop-types";

export default function Checkbox({ isIndeterminate, checked, ...rest }) {
  const setCheckboxRef = checkbox => {
    if (checkbox) {
      checkbox.indeterminate = isIndeterminate;
    }
  };

  return (
    <input type="checkbox" ref={setCheckboxRef} checked={checked} {...rest} />
  );
}

Checkbox.propTypes = {
  isIndeterminate: bool,
};

Checkbox.defaultProps = {
  isIndeterminate: false,
};
